import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import DatePicker from 'react-datepicker';

export default function QueryForm({ updateQuery, query, regions = [], eventTypes = [] }) {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const {
    setValue,
    reset,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onSubmit = (data) => {
    const queryParams = {
      keywords: data.keywords,
      region: data.region,
      type: data.type,
      startDate: startDate ? startDate.toLocaleDateString('en-CA') : '',
      endDate: endDate ? endDate.toLocaleDateString('en-CA') : ''
    };
    updateQuery(queryParams);
  };

  const handleStartDate = (date) => {
    setStartDate(date);
  };

  const handleEndDate = (date) => {
    setEndDate(date);
  };

  useEffect(() => {
    if (!startDate && !endDate) return;
    handleSubmit(onSubmit)();
  }, [startDate, endDate]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const initialRegion = params.get('region');

    if (initialRegion !== null) {
      setValue('region', initialRegion);
      const selectInput = document.getElementById('region-input');

      for (const option of selectInput) {
        if (option.value.toLowerCase() === initialRegion.toLowerCase()) {
          option.value = initialRegion;
          updateQuery({ ...query, region: initialRegion });
        }
      }
    }
  }, []);

  return (
    <section className="section">
      <form
        id="events-finder"
        onChange={handleSubmit(onSubmit)}
        className="events-finder"
      >
        <div className="container container--xl events-finder__container">
          <div className="events-finder__content">
            <div className="events-finder__field-1">
              <label className="events-finder__label events-finder__label--lead">
                Find an Event
                <div
                  onClick={() => {
                    setStartDate();
                    setEndDate();
                  }}
                  className="events-finder__reset-wrapper"
                >
                  Clear Filters
                  <input
                    type="reset"
                    className="events-finder__reset-btn"
                    onClick={() => {
                      reset({ keywords: '', region: '', type: '' });
                      updateQuery({
                        keywords: '',
                        region: '',
                        type: '',
                        startDate: '',
                        endDate: ''
                      });
                    }}
                  />
                </div>
              </label>
              <div className="events-finder__input-wrapper">
                <input
                  name="keywords"
                  className="events-finder__input"
                  placeholder="Keywords"
                  {...register('keywords')}
                />
                <i className="icon-search"></i>
              </div>
            </div>
            <div className="events-finder__field-2">
              <label className="events-finder__label">Region</label>
              <div className="events-finder__input-wrapper">
                <select
                  name="region"
                  id="region-input"
                  className="events-finder__input"
                  {...register('region')}
                >
                  <option value="">Select Region</option>
                  {regions.map((r) => (
                    <option key={r} value={r}>{r}</option>
                  ))}
                </select>
                <i className="icon-caret-down"></i>
              </div>
            </div>
            <div className="events-finder__field-3">
              <label className="events-finder__label">Event Type</label>
              <div className="events-finder__input-wrapper">
                <select
                  name="type"
                  className="events-finder__input"
                  {...register('type')}
                >
                  <option value="">Select Type</option>
                  {eventTypes.map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
                <i className="icon-caret-down"></i>
              </div>
            </div>
            <div className="events-finder__field-4">
              <label className="events-finder__label">Date Range</label>
              <div className="events-finder__input-wrapper">
                <DatePicker
                  selected={startDate}
                  onChange={(date) => handleStartDate(date)}
                  placeholderText="From"
                />
                <i className="icon-calendar larger-input"></i>
              </div>
            </div>
            <div className="events-finder__field-5">
              <label className="events-finder__label"></label>
              <div className="events-finder__input-wrapper">
                <DatePicker
                  selected={endDate}
                  onChange={(date) => handleEndDate(date)}
                  placeholderText="To"
                />
                <i className="icon-calendar larger-input"></i>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  );
}
